// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-profile-edit-form {
    max-width: 650px;
    margin: 0 auto;
}

.user-profile-edit-form .form-field {
    padding: 10px;
    align-items: center;
}
.user-profile-edit-form .user-profile-edit-form__profile-image {
    display: block;
    margin: 0 auto;
    width: 200px;
    text-align: center;
}
svg.user-profile-edit-form__placeholder {
    display: block;
    width: 200px;
    margin: 10px auto;
    color: var(--main-icon-color);
}
.user-profile-edit-form .submit {
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./client/pages/users/views/UserProfileEditForm.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,cAAc;IACd,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,6BAA6B;AACjC;AACA;IACI,kBAAkB;AACtB","sourcesContent":[".user-profile-edit-form {\n    max-width: 650px;\n    margin: 0 auto;\n}\n\n.user-profile-edit-form .form-field {\n    padding: 10px;\n    align-items: center;\n}\n.user-profile-edit-form .user-profile-edit-form__profile-image {\n    display: block;\n    margin: 0 auto;\n    width: 200px;\n    text-align: center;\n}\nsvg.user-profile-edit-form__placeholder {\n    display: block;\n    width: 200px;\n    margin: 10px auto;\n    color: var(--main-icon-color);\n}\n.user-profile-edit-form .submit {\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
